import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  signInWithPopup,
  signInWithPhoneNumber,
  GoogleAuthProvider,
  GithubAuthProvider,
  OAuthProvider,
  sendPasswordResetEmail
} from "firebase/auth";
import { auth } from "../firebase";

export const signUp = async (email, password) => {
    return await createUserWithEmailAndPassword(auth, email, password);
}

export const logIn = async (email, password) => {
    return await signInWithEmailAndPassword(auth, email, password);
}

export const logOut = async () => {
    sessionStorage.clear();
    return await signOut(auth);
}

export const signInUsingPhoneNumber = async (number) => {
    return await signInWithPhoneNumber(auth, number);
}

export const googleSignIn = async () => {
    const googleAuthProvider = new GoogleAuthProvider();
    googleAuthProvider.setCustomParameters({
        prompt: 'select_account',  // Force the account selection prompt
    });
    return signInWithPopup(auth, googleAuthProvider);
}

export const linkedInSignIn = async () => {
    const provider = new OAuthProvider('oidc.linkedin');
    provider.setCustomParameters({
        // Target specific email with login hint.
        login_hint: 'user@example.com'
    });
    return await signInWithPopup(auth, provider);

    // try {
    //     // Sign in with popup and get the result
    //     const result = await signInWithPopup(auth, provider);
      
    //     // Get the OAuth credential
    //     const credential = OAuthProvider.credentialFromResult(result);
      
    //     if (credential) {
    //       // Extract the access token and ID token
    //       const accessToken = credential.accessToken;
    //       const idToken = credential.idToken;
      
    //       console.log('Access Token:', accessToken);
    //       console.log('ID Token:', idToken);
    //     }
    // } catch (error) {
    //     console.error('Error during sign-in:', error);
    // }
      
}

export const githubSignIn = async () => {
    const githubAuthProvider = new GithubAuthProvider();
    githubAuthProvider.setCustomParameters({
        prompt: 'select_account',  // Force the account selection prompt
    });
    return signInWithPopup(auth, githubAuthProvider);
}

export const appleSignIn = async () => {
    const provider = new OAuthProvider('apple.com');
    provider.addScope('email');
    provider.addScope('name');
    return await signInWithPopup(auth, provider);
}

export const sendPasswordReset  = async (email) => {
    return await sendPasswordResetEmail(auth, email);
}